module.exports = __webpack_public_path__ + "static/media/asurion-hero-desktop-big.384d07df.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-hero-desktop-big.jpg
// module id = 1381
// module chunks = 0